import DreamHome from "./DreamHomeList";
import HomeIcon from '@material-ui/icons/Home';
import CreateDreamHome from "./CreateDreamHome";
import EditDreamHome from "./EditDreamHome";
import ShowDreamHome from "./ShowDreamHome";

export default { 
   list: DreamHome,
   create: CreateDreamHome,
   edit: EditDreamHome,
   show: ShowDreamHome,
   icon: HomeIcon
}